import React from 'react'

export default function Tablegrid(props) {
    const {table,
    isSuperAdmin,
    id,
    selectedId,
    isUserAdmin,
    showAllData} = props
  return (
    <div>{
         table?.map((data) => {
                    return (
                      <div class="txn-item" key={data.id}>
                        <div class="txn-head" id="txnhead1">
                          <div
                            class="collapsed"
                            data-bs-toggle="collapse"
                            data-bs-target="#txn1"
                            aria-expanded="false"
                            aria-controls="txn1"
                          >
                            <div
                              class={`txncard ${
                                data.status === "SUCCESS"
                                  ? "success grbg"
                                  : `${
                                      data.status === "PENDING" ||
                                      data.status === "PROCESSING" ||
                                      data.status === "HUNG" ||
                                      data.status === "ACCEPTED"
                                        ? "pending ylbg"
                                        : "failed rdbg"
                                    }`
                              }`}
                            >
                              <div class="row">
                                <div class={`col-12 ${ ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? "col-md-4" : "col-md-5"}`}>
                                  <div class="txntxt">
                                    {/* <li className="bill"> */}
                                    {/* <img src={require('../../assests/images/airtel.png')} alt="logo"/> */}
                                      <h5>
                                        {data.txnCategory}
                                      </h5>
                                    {/* </li> */}
                                  </div>
                                  <div class="txntxt">
                                    <h6>Transaction ID: {data?.id}</h6>
                                  </div>
                                </div>
                                {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                                <div class="col-12 col-md-4">
                                  <div class="txntxt">
                                    <h6>Mobile: {data?.transaction?.mobile !== undefined &&  data?.transaction?.mobile !== null ? data?.transaction?.mobile :''}</h6>
                                    { ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? 
                                              <h6>
                                              Agent Id:{" "}
                                              {data.agentId}
                                            </h6> :
                                              <h6>
                                                <span>
                                                  {" "}
                                                  {data.createdOn
                                                    .replace("T", " ")
                                                    .slice(0, -4)}{" "}
                                                </span>{" "}
                                              </h6>
                                              }
                                  </div>
                                </div>
                                <div class="col-12 col-md-2">
                                  <div class="txntxt">
                                    <h4>
                                      ₹ {data?.transaction?.amount}{" "}</h4>
                                      <h4> <span
                                        class={`${
                                          data.status === "SUCCESS"
                                            ? "success"
                                            : `${
                                                data.status === "PENDING" ||
                                                data.status === "PROCESSING" ||
                                                data.status === "HUNG" ||
                                                data.status === "ACCEPTED"
                                                  ? "pending"
                                                  : "failed"
                                              }`
                                        }`}
                                      >
                                        {data.status}
                                      </span>
                                     
                                    </h4>
                                  </div>
                                </div>
                                <div class= {`col-12  ${((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? "col-md-2" : "col-md-1"} float-right`}>
                                        <div class="txntxt">
                                        {isSuperAdmin(id) &&  <button type="button"  style={{float:'right',backgroundColor:'rgb(159, 166, 178)'}} className="btn dbbtn" onClick={()=>showAllData(data)} ><i class="bi bi-eye-fill"></i> Logs</button>}
                                        { ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) &&
                                                <h6 style={{float:'right'}} >
                                                <span>
                                                  {" "}
                                                  {data.createdOn
                                                    .replace("T", " ")
                                                    .slice(0, -4)}{" "}
                                                </span>{" "}
                                              </h6>
                                              }
                                        </div>
                                      </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
    </div>
  )
}
